export default __webpack_public_path__ + "static/media/filter.a50bc6b2.svg";